"use client";

// Custom global-error page.
// Workaround for a Next.js 16 prerender bug where the default
// /_global-error page calls useContext during static generation
// and fails with: "Cannot read properties of null (reading 'useContext')".
// A user-provided global-error.tsx replaces the default and renders fine.

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="de">
      <body
        style={{
          margin: 0,
          fontFamily: "system-ui, -apple-system, sans-serif",
          background: "#f8fafc",
          color: "#0f172a",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            maxWidth: 480,
            padding: "2rem",
            textAlign: "center",
          }}
        >
          <h1 style={{ fontSize: "1.5rem", margin: "0 0 0.5rem" }}>
            Etwas ist schiefgelaufen
          </h1>
          <p style={{ color: "#64748b", margin: "0 0 1.5rem" }}>
            Ein unerwarteter Fehler ist aufgetreten. Bitte lade die Seite neu.
          </p>
          {error?.digest && (
            <p style={{ fontSize: "0.75rem", color: "#94a3b8", margin: "0 0 1.5rem" }}>
              Fehler-ID: {error.digest}
            </p>
          )}
          <button
            type="button"
            onClick={() => reset()}
            style={{
              padding: "0.5rem 1.25rem",
              background: "#0f172a",
              color: "white",
              border: 0,
              borderRadius: "0.5rem",
              cursor: "pointer",
              fontSize: "0.875rem",
            }}
          >
            Erneut versuchen
          </button>
        </div>
      </body>
    </html>
  );
}
